import Link from "next/link"

interface OwnerInfoMobileProps {
    infoTitle: string,
    infoValue?: string | null
    href?: string
}

function OwnerInfoMobile({ infoTitle, infoValue, href }: OwnerInfoMobileProps) {
    const content = infoValue ?? "N/A"
    const isTelLink = href?.startsWith('tel:')
    const isExternalHttp =
        href?.startsWith('http://') || href?.startsWith('https://')

    return (
        <div>
            <h3 className="text-muted-foreground text-xs font-medium">{infoTitle}</h3>
            {href ? (
                isTelLink ? (
                    <a href={href} className="text-primary hover:underline text-sm">
                        {content}
                    </a>
                ) : isExternalHttp ? (
                    <a
                        href={href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-primary hover:underline text-sm"
                    >
                        {content}
                    </a>
                ) : (
                    <Link href={href} className="text-primary hover:underline text-sm">
                        {content}
                    </Link>
                )
            ) : (
                <p className="text-foreground text-sm">{content}</p>
            )}
        </div>
    )
}

export default OwnerInfoMobile
